export const SET_MUTE_TOGGLE = "SET_MUTE_TOGGLE";
export const SET_VIDEO_TOGGLE = "SET_VIDEO_TOGGLE";
export const SHOW_HEADER = "SHOW_HEADER";
export const HIDE_HEADER = "HIDE_HEADER";
export const HIDE_FOOOTER = "HIDE_FOOOTER";
export const SHOW_FOOOTER = "SHOW_FOOOTER";

  
